import React, { useCallback } from 'react';
import { useEffect } from "react";
import { personHref } from 'components/langutils';
import { useData } from '../Data';

export function HashSelect() {
  const { users, setCurrent, lang } = useData();
  const hashchange = useCallback(() => {
    const page = document.location.hash.slice(1);
    const person = page === 'alumni' ? null : users?.find((u: any) => u.login === page);
    if (person) {
      // an old address of a person (the team page with the login after "#"): go to their own page
      location.replace(personHref(person, lang));
      return;
    }
    setCurrent(page === 'alumni' ? 'alumni' : null);
  }, [setCurrent, users, lang]);
  useEffect(() => {
    addEventListener('hashchange', hashchange);
    return () => {
      removeEventListener('hashchange', hashchange);
    };
  }, [hashchange]);
  useEffect(() => {
    hashchange();
  });
  return <></>;
}
